const minimumWidth = 250

/**
* Positions the dropdown left or right align based on where the element is positioned.
*/
const positionDropdown = (dropdownList: HTMLUListElement, component: Vue, position: { width: string, top: string, left: string }) => {
	dropdownList.style.top = position.top

	// Set minimum width to 250px.
	let width = parseInt(position.width) < minimumWidth ? minimumWidth : parseInt(position.width)
	dropdownList.style.width = width + "px"

	// Set left position. Offset menu if it clips off the right of the viewport.
	let left = parseInt(position.left)
	if ((left + width) >= document.documentElement.clientWidth) {
		dropdownList.style.left = (left - width + parseInt(position.width)) + "px"
	} else { dropdownList.style.left = left + "px" }
}

export default positionDropdown
